import React from 'react'
function Strengths_comp() {
  return (
    <div>
      {/* ------------------------------Mobile View--------------------------- */}
    <div className='stregths_page_img d-sm-block d-md-none mb-4'>
    <div className='container pt-4'>
    <div className='text-center staff_component_text'>
        <h2 className=" display-4">Our Strengths</h2>
        <p className="">Our features are what make us who we are.</p>
    </div>
    </div>
    <div className='container px-3'>
    <div className='row pt-1 mobile_staff_component_text'>
    <div className='col-md-12'>
            <div className=''>
                <h2 className='fs-6'>6 Month Course Access</h2>
                <p className=''>We provide 6 month course access to a variety of courses that will help you stay ahead of the curve in your field.</p>
            </div>
        </div>
        <div className='col-md-12'>
            <div className=''>
                <h2 className='fs-6'>Live Session & Mentorship</h2>
                <p className=''>Discover dynamic live courses led by experts, tailored to your needs. Our impactful approach includes personalized guidance, empowering you to exceed goals.</p>
            </div>
        </div>
        <div className='col-md-12'>
            <div className=''>
                <h2 className='fs-6'>Capstone Projects</h2>
                <p className=''>Dedicated to delivering well-written, researched projects. We understand the importance of excellence, ensuring your work meets the highest standards.</p>
            </div>
        </div>
    </div>
    <div className='row mobile_staff_component_text'>
    <div className='col-md-12'>
            <div className=''>
                <h2 className='fs-6'>Live Skill Development Session</h2>
                <p className=''>Empower your career with Live Skill Development experts guide resume building, pre-interview prep, LinkedIn optimization, mastering interviews. Success in today's dynamic job market awaits!</p>
            </div>
        </div>
        <div className='col-md-12'>
            <div className=''>
                <h2 className='fs-6'>Paid Internship Opportunity</h2>
                <p className=''>Explore paid internships in our courses. Elevate your career with hands-on experience. Completion opens doors to exciting paid opportunities for a dynamic professional journey.</p>
            </div>
        </div>
        <div className='col-md-12'>
            <div className=''>
                <h2 className='fs-6'>Certifications</h2>
                <p className=''>Gain recognition with our Internship and Course Completion Certificates. Showcase achievements and skills to employers with our validated certifications.</p>
            </div>
        </div>
    </div>
    </div>
    </div>

    {/* ----------------------------Desktop View-------------------------------- */}
    <div className='stregths_page_img d-none d-md-block mb-2'>    
    <div className='container pt-5 pb-4'>
    <div className='text-center staff_component_text'>
    <h2 className="display-5">Our Strengths</h2>
    <h3 className="pt-1 pb-4">Our features are what make us who we are.</h3>
    </div>
    <div className='container '>
    <div className='row text-center staff_component_text'>
    <div className='col-md-4'>
            <div className=''>
                <h2 className='fs-5'>6 Month Course Access</h2>
                <p className=''>We provide 6 month course access to a variety of courses that will help you stay ahead of the curve in your field.</p>
            </div>
        </div>
        <div className='col-md-4'>
            <div className=''>
                <h2 className='fs-5'>Live Session & Mentorship</h2>
                <p className=''>Discover dynamic live courses led by experts, tailored to your needs. Our impactful approach includes personalized guidance, empowering you to exceed goals.</p>
            </div>
        </div>
        <div className='col-md-4'>
            <div className=''>
                <h1 className='fs-5'>Capstone Projects</h1>
                <p className=''>Dedicated to delivering well-written, researched projects. We understand the importance of excellence, ensuring your work meets the highest standards.</p>
            </div>
        </div>
    </div>
    <div className='row mt-4 text-center staff_component_text'>
    <div className='col-md-4'>
            <div className=''>
                <h2 className='fs-5'>Live Skill Development Session</h2>
                <p className=''>Empower your career with Live Skill Development—experts guide resume building, pre-interview prep, LinkedIn optimization, mastering interviews. Success in today's dynamic job market awaits!</p>
            </div>
        </div>
        <div className='col-md-4'>
            <div className=''>
                <h2 className='fs-5'>Paid Internship Opportunity</h2>
                <p className=''>Explore paid internships in our courses. Elevate your career with hands-on experience. Completion opens doors to exciting paid opportunities for a dynamic professional journey.</p>
            </div>
        </div>
        <div className='col-md-4'>
            <div className=''>
                <h2 className='fs-5'>Certifications</h2>
                <p className=''>Gain recognition with our Internship and Course Completion Certificates. Showcase achievements and skills to employers with our validated certifications.</p>
            </div>
        </div>
    </div>
    </div>
    </div>
    </div>
    </div>
  )
}

export default Strengths_comp
